@import (reference) "../../references.less";

.root {
  display: block;
}

.loading {
  .font-sacramento-regular();
  .R(font-size, 50, 120);
  .absoluteCenter();
  color: @color-white;
  .element-blink-animation();
}
